function BatchImportCtrl($scope,$controller,$location) {

    $scope.type = $location.search()["type"];
    $scope.config = {};

    store.fetch({
        path: '/batchConfiguration',
        queryParams: {'type': $scope.type},
        success: function(data) {
            $scope.batchConfiguration = data;
            $scope.config.method = $scope.batchConfiguration.methods[0];
        }
    });
    
  
}



